import {
  REQUIRED_EMAIL_VALIDATOR,
  REQUIRED_TEXT_FIELD_VALIDATOR,
  TEXT_FIELD_VALIDATOR,
} from '@/helpers/formHelpers/validators';
import { object, ObjectSchema } from 'yup';

export type SignUpValidationSchemaType = {
  user: {
    email: string;
    first_name: string;
    last_name: string;
  };
  organization: {
    name: string;
  };
};

export const SIGN_UP_VALIDATION_SCHEMA: ObjectSchema<SignUpValidationSchemaType> = object().shape({
  user: object().shape({
    email: REQUIRED_EMAIL_VALIDATOR,
    first_name: REQUIRED_TEXT_FIELD_VALIDATOR,
    last_name: REQUIRED_TEXT_FIELD_VALIDATOR,
  }),
  organization: object().shape({
    name: TEXT_FIELD_VALIDATOR,
  }),
}) as ObjectSchema<SignUpValidationSchemaType>;

export const SIGN_UP_INITIAL_VALUES = {
  user: {
    email: '',
    first_name: '',
    last_name: '',
  },
  organization: {
    name: '',
  },
};
